
	import {
		Request
	} from '@/api/request';
	import { ElMessage } from 'element-plus'
	import {
		defineComponent,
		ref,
		reactive,
		inject,
		provide,
		onMounted,
		watch
	} from "vue";
	import { useRoute, useRouter } from 'vue-router'
	const rules: any = {
		title: [
			{required: true, message: '请输入优惠卷名称', trigger: 'blur'},
		],
		time: [
			{required: true, message: '请选择活动区域', trigger: 'change' }
		],
		type: [
			{required: true, message: '请选择活动区域', trigger: 'change' }
		]
	}
	
	export default defineComponent({
		name: "operateCoupon_add",
		setup() {
			const Router = useRouter();
			const setTitle: any = inject("setTitle");
			setTitle(["优惠卷管理", '发放优惠券']);
			let form: any = ref({
					title: '',
					type: 1,
					start_time: '',
					end_time: '',
					reduce_price: '',
					full_price: '',
					full_reduce_fee: '',
					direct_reduce_fee: '',
					project_id: '',
					time: null,
				}),
				formRef = ref(null),
				checkboxs: any = ref({
					full_reduce_type: true,
					direct_reduce_type: false,
					full_reduce_project: true,
					direct_reduce_project: false,
				}),
				projectList = ref([] as Array<any>),
				form_load = ref(false)
			let getprojectList = () => {
					Request.axiosInstance({
						url: 'adminapi/Project/list',
						data: {},
					}).then((res: any) => {
						let list = res?.content?.list || []
						projectList.value = list
					})
				},
				changeCheckbox = (type: number, index: number) => {
					if(type == 0)
					{
						checkboxs.value.full_reduce_type = false
						checkboxs.value.direct_reduce_type = false
						form.value.type = index + 1
					}
				},
				_option = (id: number, text: string) => {
					Router.push({
						path: '/framework/' + text,
						query: {
							id: id
						}
					})
				},
				onSubmit = () => {
					(formRef.value as any).validate((valid: boolean) => {
						if(!valid) return
						else if(form.value.type == 1
								&& (!form.value.full_price || !form.value.full_reduce_fee))
						{
							ElMessage({
								showClose: true,
								message: '满减卷必填',
								type: 'error'
							});
						}
						else if(form.value.type == 2 && !form.value.direct_reduce_fee){
							ElMessage({
								showClose: true,
								message: '无门槛券必填',
								type: 'error'
							});
						}
						
						else
						{
							if(form.value.type==1){
								form.value.reduce_price = form.value.full_reduce_fee;
							}else if(form.value.type==2){
								form.value.reduce_price = form.value.direct_reduce_fee;
								form.value.full_price = '';
							}else{
								return
							}
							delete form.value.full_reduce_fee;
							delete form.value.direct_reduce_fee;
							form_load.value = true
							form.value.start_time = Date.parse(form.value.time[0])/1000;
							form.value.end_time = Date.parse(form.value.time[1])/1000;
							Request.axiosInstance({
								url: "adminapi/Coupon/create",
								data: form.value
							}).then((res: any) => {
								Router.go(-1)
							})
						
						}
						
					})
				}
				
			onMounted(() => {
	
				getprojectList()
			})
		
			return {
				form,
				formRef,
				rules,
				changeCheckbox,
				checkboxs,
				projectList,
				getprojectList,
				onSubmit,
				form_load,
				Router,
				_option
			};
		
		},
	});
